import { useState } from "react"
import Popover from "@mui/material/Popover"
import Typography from "@mui/material/Typography"

const NewCategoryModal = ({ setRefresh }) => {
  const [newCategory, setNewCategory] = useState("")
  const [imageUrl, setImageUrl] = useState("")
  const [message, setMessage] = useState("")
  const [anchorEl, setAnchorEl] = useState(null)

  const addNewCategory = async (target) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/categories`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: newCategory.trim(),
          image: imageUrl.trim(), // ✅ FIXED
          subCategories: [], // still allowed
        }),
      })

      const data = await res.json()

      if (!res.ok) {
        setMessage(
          data?.error || "Failed to create category (maybe duplicate name)",
        )
      } else {
        setMessage("Category successfully created!")
        setRefresh(true)
        setNewCategory("")
        setImageUrl("")
      }

      setAnchorEl(target)
    } catch (err) {
      setMessage("Server error while creating category")
      setAnchorEl(target)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!newCategory.trim() || !imageUrl.trim()) {
      setMessage("Name and Image URL are required")
      setAnchorEl(e.currentTarget)
      return
    }

    addNewCategory(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? "new-category-popover" : undefined

  return (
    <>
      <div
        className="modal fade"
        id="newCategoryModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-4">Create New Category</h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3 col-10 mx-auto">
                  <label className="form-label fs-4">Name:</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={newCategory}
                    onChange={(e) => setNewCategory(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-10 mx-auto">
                  <label className="form-label fs-4">Image URL:</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={imageUrl}
                    onChange={(e) => setImageUrl(e.target.value)}
                  />
                </div>

                <div className="row justify-content-end">
                  <div className="col-3 mt-1">
                    <button type="submit" className="btn btn-primary btn-lg">
                      Create
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Typography onMouseLeave={handleClose} sx={{ p: 2 }}>
          {message}
        </Typography>
      </Popover>
    </>
  )
}

export default NewCategoryModal
